import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
class UserAlertsRepository extends Repository {
  createAlert() {
    throw new Error('[UserAlertsRepository#createAlert] must be implemented')
  }

  getUserAlerts({userId}) {
    throw new Error('[UserAlertsRepository#getUserAlerts] must be implemented')
  }

  updateUserAlert({userId, parsedUserAlert}) {
    throw new Error('[UserAlertsRepository#updateUserAlert] must be implemented')
  }

  unsubscribeAlert({userId, alertId}) {
    throw new Error('[UserAlertsRepository#unsubscribeAlert] must be implemented')
  }
}

export default UserAlertsRepository
